import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=1a4bd250&scoped=true&"
import script from "./DownloadCenter.vue?vue&type=script&lang=js&"
export * from "./DownloadCenter.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCenter.vue?vue&type=style&index=0&id=1a4bd250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bd250",
  null
  
)

export default component.exports